/**
 * Maps division, brand, and field of play combinations to project IDs
 * Key format: "division|brand|fieldOfPlay"
 */
export const PROFILE_SAVED_VIEW_MAPPING = {
    'Accessories|Nike|Jordan Sport': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Accessories|Nike|Jordan Streetwear': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Accessories|Nike|Kids Basketball': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'Accessories|Nike|Kids Football': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'Accessories|Nike|Mens Basketball': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'Accessories|Nike|Mens Fitness': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'Accessories|Nike|Mens Football': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'Accessories|Nike|Mens Running': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'Accessories|Nike|Womens Sport': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'Accessories|Nike|Womens Lifestyle': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Accessories|Nike Air|Jordan Sport': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Accessories|Nike Air|Jordan Streetwear': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'Accessories|Nike Air|Kids Basketball': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'Accessories|Nike Air|Mens Basketball': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'Accessories|Nike Air|Mens Running': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'Accessories|Nike Air|Womens Sport': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'Accessories|Jordan|Jordan Sport': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'Accessories|Jordan|Jordan Streetwear': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'Accessories|Jordan|Mens Basketball': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Accessories|Jordan|Mens Football': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'All|Nike|Jordan Sport': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'All|Nike|Kids Basketball': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'All|Nike|Kids Football': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'All|Nike|Mens Basketball': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'All|Nike|Mens Fitness': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'All|Nike|Mens Football': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'All|Nike|Mens Running': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'All|Nike|Womens Sport': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'All|Nike|Womens Lifestyle': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'All|Nike Air|Jordan Sport': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'All|Nike Air|Jordan Streetwear': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'All|Nike Air|Mens Basketball': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'All|Nike Air|Mens Running': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'All|Nike Air|Womens Lifestyle': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'All|Jordan|Jordan Sport': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'All|Jordan|Jordan Streetwear': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'All|Jordan|Mens Basketball': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'All|Jordan|Kids Basketball': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Equipment|Nike|Mens Fitness': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'Equipment|Nike|Mens Running': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'Equipment|Nike|Womens Sport': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'Equipment|Nike Air|Mens Fitness': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'Equipment|Jordan|Mens Basketball': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'Apparel|Nike|Jordan Sport': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'Apparel|Nike|Jordan Streetwear': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'Apparel|Nike|Kids Basketball': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Apparel|Nike|Mens Basketball': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Apparel|Nike|Mens Football': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'Apparel|Nike|Mens Running': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'Apparel|Nike|Womens Sport': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'Apparel|Nike|Womens Lifestyle': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'Apparel|Nike Air|Jordan Sport': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'Apparel|Nike Air|Mens Running': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'Apparel|Nike Air|Womens Lifestyle': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'Apparel|Jordan|Jordan Sport': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Apparel|Jordan|Jordan Streetwear': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Apparel|Jordan|Mens Basketball': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'Footwear|Nike|Jordan Sport': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'Footwear|Nike|Kids Basketball': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'Footwear|Nike|Kids Football': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'Footwear|Nike|Mens Basketball': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'Footwear|Nike|Mens Fitness': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'Footwear|Nike|Mens Football': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'Footwear|Nike|Mens Running': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Footwear|Nike|Womens Sport': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Footwear|Nike|Womens Lifestyle': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    'Footwear|Nike Air|Jordan Sport': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    },
    'Footwear|Nike Air|Kids Basketball': {
        projectId: 'f38b7ec6-e84e-42e5-bd30-9cd5a5847d36'
    },
    'Footwear|Nike Air|Mens Basketball': {
        projectId: '04eaa2c5-f217-4eac-ac1e-54ed1b811905'
    },
    'Footwear|Nike Air|Mens Running': {
        projectId: '132ac144-6cf0-4710-9145-69820b56dff0'
    },
    'Footwear|Nike Air|Womens Sport': {
        projectId: 'ef3f0b68-90ae-4d54-a686-c7a298e8af36'
    },
    'Footwear|Jordan|Jordan Sport': {
        projectId: '85c12438-746a-46ba-89bc-42f5aea0dd60'
    },
    'Footwear|Jordan|Jordan Streetwear': {
        projectId: 'f52f0ddc-c808-4695-8246-dc33980f0625'
    },
    'Footwear|Jordan|Kids Basketball': {
        projectId: '95016a3f-6d36-44f8-b3ed-0a7d111c5712'
    },
    'Footwear|Jordan|Mens Basketball': {
        projectId: '9e479ed6-1867-46b5-89fe-a0efdcece856'
    },
    '*|*|*': {
        projectId: '69d4b718-6ccc-48f8-8799-78a7258dc16e'
    }
};
